import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { ResourceComponent } from './pages/resource/resource.component';
import { AboutComponent } from './pages/about/about.component';
import { ContactComponent } from './pages/contact/contact.component';
import { IndexComponent } from './pages/index/index.component';
import { SearchComponent } from './pages/search/search.component';
import { PredisclaimerComponent } from './pages/predisclaimer/predisclaimer.component';
import { PreDisclaimerGuard } from './guards/predisclaimer.guard';
import { TermofuseComponent } from './pages/termofuse/termofuse.component';
import { UsdisclaimerComponent } from './pages/usdisclaimer/usdisclaimer.component';
import { BloombergLandingComponent } from './pages/bloomberg-landing/bloomberg-landing.component';

export const routes: Routes = [
  { path: 'home', component: HomeComponent, canActivate: [PreDisclaimerGuard] },
  {
    path: 'resource',
    component: ResourceComponent,
    canActivate: [PreDisclaimerGuard],
  },
  {
    path: 'about',
    component: AboutComponent,
    canActivate: [PreDisclaimerGuard],
  },
  {
    path: 'contact',
    component: ContactComponent,
    canActivate: [PreDisclaimerGuard],
  },
  {
    path: 'index',
    component: IndexComponent,
    canActivate: [PreDisclaimerGuard],
  },
  {
    path: 'Strategy/Index',
    component: IndexComponent,
    canActivate: [PreDisclaimerGuard],
  },
  {
    path: 'termofuse',
    component: TermofuseComponent,
  },
  {
    path: 'usdisclaimer',
    component: UsdisclaimerComponent,
    canActivate: [PreDisclaimerGuard],
  },
  {
    path: 'search',
    component: SearchComponent,
    canActivate: [PreDisclaimerGuard],
  },
  { path: 'predisclaimer', component: PredisclaimerComponent },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: ':bloombergCode',
    component: BloombergLandingComponent,
    canActivate: [PreDisclaimerGuard],
    pathMatch: 'full'
  },
  { path: '**', redirectTo: 'home' },
];
